import { render } from "./ChatImageGallery.vue?vue&type=template&id=6c09227c&scoped=true"
import script from "./ChatImageGallery.vue?vue&type=script&lang=js"
export * from "./ChatImageGallery.vue?vue&type=script&lang=js"

import "./ChatImageGallery.vue?vue&type=style&index=0&id=6c09227c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c09227c"]])

export default __exports__